import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        traveller: {
            documents: []
        },
        loading: false,
        history_loading: false,
        histories: [],
        scan_history_loading: false,
        scan_histories: [],
        next_page_url: '',
        scan_next_page_url: '',
        filters: {
            type: null,
            year: null
        },
        profile_images: [],
        special_case_payment_dialog: false,
        entry_refuse_dialog: false,
        special_case_payment_detail: {},
        special_case_payment_voucher: {},
    }
}

const getters = {
    loading: state => state.loading,
    traveller: state => state.traveller,
    history_loading: state => state.history_loading,
    scan_history_loading: state => state.scan_history_loading,
    filters: state => state.filters,
    profile_images: state => state.profile_images,
    special_case_payment_dialog: state => state.special_case_payment_dialog,
    entry_refuse_dialog: state => state.entry_refuse_dialog,
    special_case_payment_detail: state => state.special_case_payment_detail,
    special_case_payment_voucher: state => state.special_case_payment_voucher,
};

const actions = {
    async getTravellerDetail({commit, state}, id) {
        commit('setLoading', true);
        try {
            const {data} = await Http.get(API_URL + VERSION + '/travellers-histories/get/' + id);
            commit('setLoading', false);
            commit('setTraveller', data.data);
        } catch (error) {
            commit('setLoading', false);
            throw error;
        }
    },

    async getTravellerProfileImages({commit, state}, id) {
        commit('setLoading', true);
        try {
            const {data} = await Http.get(`${API_URL}${VERSION}/travellers-histories/${id}/get-profile-images`);
            commit('setLoading', false);
            commit('setTravellerImages', data.data);
        } catch (error) {
            commit('setLoading', false);
            throw error;
        }
    },

    async getHistory({commit, state}, id) {
        commit('setHistoryLoading', true);
        try {
            let data = null;
            if (id != null) {
                if (id === 'data') {
                    const response = await Http.get(API_URL + VERSION + '/travellers-histories/tracks/' + state.traveller.id, {
                        params: state.filters
                    });
                    data = response.data;
                } else {
                    const response = await Http.get(API_URL + VERSION + '/travellers-histories/tracks/' + id, {
                        params: state.filters
                    });
                    data = response.data;
                }
            } else {
                const response = await Http.get(state.next_page_url, {
                    params: state.filters
                });
                data = response.data;
            }
            commit('setHistories', data)

            commit('setHistoryLoading', false);
        } catch (e) {
            console.log(e);
            commit('setHistoryLoading', false);
            throw e;
        }
    },
    async getScanHistory({commit, state}, id) {
        commit('setScanHistoryLoading', true);
        try {
            let data = null;
            if (id != null) {
                if (id === 'data') {
                    const response = await Http.get(API_URL + VERSION + '/travellers-histories/scan-tracks/' + state.traveller.id, {
                        params: state.filters
                    });
                    data = response.data;
                } else {
                    const response = await Http.get(API_URL + VERSION + '/travellers-histories/scan-tracks/' + id, {
                        params: state.filters
                    });
                    data = response.data;
                }
            } else {
                const response = await Http.get(state.scan_next_page_url, {
                    params: state.filters
                });
                data = response.data;
            }
            commit('setScanHistories', data)

            commit('setScanHistoryLoading', false);
        } catch (e) {
            console.log(e);
            commit('setScanHistoryLoading', false);
            throw e;
        }
    },

    async getSpecialCasePaymentDetail({commit}, id) {
        commit('setLoading', true);
        commit('setSpecialCasePaymentDetail', {});
        try {
            const {data} = await Http.get(`${API_URL}${VERSION}/special-case-payment/get/${id}`);
            commit('setLoading', false);
            commit('setSpecialCasePaymentVoucher', data.data);
            commit('setSpecialCasePaymentDetail', data.data);
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },
    resetState({commit}) {
        commit('resetState')
    }
};

const mutations = {
    setTraveller(state, items) {
        state.traveller = items
    },
    setTravellerImages(state, items) {
        state.profile_images = items
    },
    setSpecialCasePaymentDetail(state, res) {
        state.special_case_payment_detail = res
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setHistoryLoading(state, loading) {
        state.history_loading = loading;
    },
    setScanHistoryLoading(state, loading) {
        state.scan_history_loading = loading;
    },
    setHistories(state, histories) {
        if (histories.meta.current_page === 1) {
            state.histories = [...histories.data];
        } else {
            state.histories = [...state.histories, ...histories.data];
        }
        state.next_page_url = histories.links.next;
    },
    setScanHistories(state, histories) {
        if (histories.meta.current_page === 1) {
            state.scan_histories = [...histories.data];
        } else {
            state.scan_histories = [...state.histories, ...histories.data];
        }
        state.scan_next_page_url = histories.links.next;
    },
    setSpecialCasePaymentDialog(state, status) {
        state.special_case_payment_dialog = status;
    },
    setEntryRefuseDialog(state, status) {
        state.entry_refuse_dialog = status;
    },
    setSpecialCasePaymentVoucher(state, data) {
        state.special_case_payment_voucher = data;
    }

};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
